import React, { createContext, FC, useContext } from 'react';
import { useQuery } from 'react-query';

import { fundamentalScoreTypes } from '../constants';
import { FundamentalScoreTypesResponse } from '../types/api/quote';
import { request } from '../utils/request';

const ScoreTypesContext = createContext([] as FundamentalScoreTypesResponse['data']);

export const ScoreTypesProvider: FC = ({ children }) => {
  const { data } = useQuery('scoreTypes', () => {
    return request({ method: 'GET', url: fundamentalScoreTypes }).then((response: FundamentalScoreTypesResponse) => {
      return response.data;
    });
  });
  return <ScoreTypesContext.Provider value={data}>{children}</ScoreTypesContext.Provider>;
};

export const useScoreTypes = () => useContext(ScoreTypesContext);
